export const showPanelModal = () => {
  const logout: HTMLElement = document.querySelector('#account-panel-logout-section');
  const loading: HTMLElement = document.querySelector('#account-panel-template-loading.is-hidden');
  logout.classList.add('is-hidden');
  if (loading) {
    loading.classList.remove('is-hidden');
  }

  fetch('/wp/wp-admin/admin-ajax.php?action=get_account_panel_data')
    .then(res => {
      return res.json();
    }).then(res => {
        if (res.success) {
          const target: HTMLElement = document.querySelector('#account-panel-template-target');
          const template: HTMLElement = document.querySelector('#account-panel-template');
          const data = {
            data: res
          };
          if(target && template) {
            const compiled = _.template(template.innerHTML);

            getOtherSubscriptions();
            target.innerHTML = compiled(data);

            if(res.user_purchased_subscription) {
              const item: HTMLElement = document.querySelector('.account-panel__list-item--manage.is-hidden');
              if(item) {
                item.classList.remove('is-hidden');
              }
              if(res.active_subscription.subscription_type !== 'digital' && res.active_subscription.subscription_type !== 'unlimited') {
                item.querySelector('a').innerHTML = 'Manage your subscription &raquo;';
              }
            }
          } else {
            console.error('The template or target container is missing from the DOM.');
          }
        } else if (res.error == 'SHOW_LOGIN') {
          showLoginModal();
        }
    }).catch(err => {
      console.log('error',err);
    });
};

export const showLoginModal = () => {
  const logout: HTMLElement = document.querySelector('#account-panel-logout-section');
  const loading: HTMLElement = document.querySelector('#account-panel-template-loading');
  const target: HTMLElement = document.querySelector('#account-panel-template-target');
  const template: HTMLElement = document.querySelector('#account-login-template');
  const compiled = _.template(template.innerHTML);

  loading.classList.add('is-hidden');
  logout.classList.add('is-hidden');

  if (target && template) {
    const data = {
      data: {src: 'https://aim.dragonforms.com/loading.do?omedasite=PWWWEB_Login_Panel',
        id: 'PWWWEB_Login_panel',
        border: '0',
        height: '480',
        width: '300'}
    };
    target.innerHTML = compiled(data);
  } else {
    console.error('The template or target container is missing from the DOM.');
  }
};

const getOtherSubscriptions = () => {
  const loading: HTMLElement = document.querySelector('#account-panel-template-loading');
  loading.classList.remove('is-hidden');

  fetch('/wp/wp-admin/admin-ajax.php?action=get_aim_subscription_data')
  .then(res => {
    return res.json();
  }).then(res => {
      if (res.success || res.error == 'NO_OTHER_PRODUCTS') {
        const target: HTMLElement = document.querySelector('#account-panel-template-target');
        const template: HTMLElement = document.querySelector('#other-subscriptions-template');
        const data = {
          data: res
        };

        if(target && template) {
          const logout: HTMLElement = document.querySelector('#account-panel-logout-section');
          const compiled = _.template(template.innerHTML);

          logout.classList.remove('is-hidden');
          target.innerHTML += compiled(data);

        } else {
          console.error('The template or target container is missing from the DOM.');
        }
      } else if (res.error == 'SHOW_LOGIN') {
        showLoginModal();
      }
  }).catch(err => {
    console.log('error',err);
  }).finally(() => {
    loading.classList.add('is-hidden');
  });
}

function do_logout() {
  fetch("/wp/wp-admin/admin-ajax.php?action=member_logout", {
    headers: {
      "Content-type": "application/json"
    },
    method: "POST",
  }).then((response) => {
    if (!response.ok) {
      throw new Error('HTTP error! Status: ${response.status}');
    }
    return response.json();
  }).then((json) => {
    if (json.success) {
      let btnLogin = document.getElementById('main-nav-account-panel');
      if (btnLogin) {
        btnLogin.setAttribute("data-button-state", "login");
        btnLogin.setAttribute("data-gtm-ui", "login");
        btnLogin.setAttribute("aria-label", "Account Panel");
        btnLogin.setAttribute("title", "Login");
        btnLogin.innerHTML = "Login";
        showLoginModal();
      }
    }
  })
  .catch(error => {
    console.error("Error:",error);
  })
}

const handleModalOpen = (e) => {
  let button = e.target.closest('[data-a11y-dialog-show="account-panel-modal"]')

  if (button) {
    let dialog;
    let whichmodal = button.getAttribute('data-button-state');
    import('./init').then(module => {
      dialog = module.default();

      if (dialog) {
        dialog.show();
        window.removeEventListener('click', handleModalOpen);
      }

      if (whichmodal == 'login') {
        showLoginModal();
      } else if (whichmodal == 'account-panel') {
        showPanelModal();
      }
    }).catch(err => {
      console.log('error',err);
    });
  }
}

export default (): void => {
  window.addEventListener('click', handleModalOpen);
  const logoutButton: HTMLElement = document.querySelector('#account-panel-logout');
  if (logoutButton) {
    logoutButton.addEventListener('click', () => do_logout());
  }
}
